export default __webpack_public_path__ + "static/media/010_home.6e6eed84.mp4";